import { ValidationInputType } from "@generation/core";
import { AbstractCrossFieldValidation } from "@generation/form";
import { CustomErrorMessage } from "@generation/form/src/Validations/ValidationHelper";

export class FolderAantalFieldValidation extends AbstractCrossFieldValidation {
  key = "isFolderAantalFieldValidation";

  constructor(public readonly dependsOn: boolean = false, customErrorMessage?: CustomErrorMessage) {
    super(customErrorMessage);
  }

  validate = (_input: ValidationInputType): boolean => {
    const foldersWlz = parseInt(this.getValues("folders.eigenBijdrageWlz")) || 0;
    const foldersWmo = parseInt(this.getValues("folders.eigenBijdrageWmo")) || 0;
    const foldersWlzVorigJaar = parseInt(this.getValues("folders.eigenBijdrageWlzVorigJaar")) || 0;
    const foldersWmoVorigJaar = parseInt(this.getValues("folders.eigenBijdrageWmoVorigJaar")) || 0;
    return foldersWlz + foldersWmo + foldersWlzVorigJaar + foldersWmoVorigJaar > 0;
  };

  defaultMessage = (_label: string): string =>
    `Bij minimaal één van de Folders moet het aantal groter dan 0 zijn.`;
}
